import ParsedHtmlContent from "@/components/etc/renderContent";
import { AnalysisListTypes } from "@/type/list";
import default_image from "@/public/icon/default_user.svg"

import mark from "@/public/icon/mark.svg"
import BoardDetailV2 from "@/components/board/detail_v2";
import { useLocale, useTranslations } from "next-intl";
import LocaleFormat from "@/components/etc/localeFormat";

export default function AnalysisView({
    selectContent,
    setSelectContent,
    fetchData,
    isFirstRender
}: {
    selectContent: AnalysisListTypes | undefined;
    setSelectContent: (item: AnalysisListTypes | undefined) => void;
    fetchData: () => void,
    isFirstRender: boolean,
}) {
    const locale = useLocale();

    const t = useTranslations("Text")
    const a = useTranslations("Sentence")

    if (!selectContent) return null;

    const match = selectContent.match_result || {};
    const handicap = selectContent.handicap_result || {};
    const under_over = selectContent.under_over_result || {};

    return (
        <BoardDetailV2 selectContent={selectContent}
            setSelectContent={setSelectContent}
            fetchData={fetchData}
            className={"board-view sports-analysis-container"}
            isComment={false}
            isrecommend={false}
            isFirstRender={isFirstRender}
            renderBody={(c) => (
                <>
                    <div className="view-title">
                        <header >
                            <div className="title">{selectContent.title}</div>
                            <div className="author">
                                <div className="profile-image">
                                    <img src={default_image.src} alt="" />
                                </div>
                                <div className="info">
                                    <div className="other">
                                        <div className="nickname">{selectContent.author_name}</div>
                                        <span><LocaleFormat date={selectContent.create_dt} format="MM-DD HH:mm" /></span>
                                    </div>
                                </div>
                            </div>
                        </header>
                    </div>
                    <main>
                        <ul className="sports-analysis-list view-detail">
                            <li>
                                <div>
                                    {
                                        selectContent.home_team_logo
                                            ? <img src={selectContent.home_team_logo}
                                                alt="logo A"
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoA.png').default.src}`;
                                                }} />
                                            : <img className="team-amb" src={require(`@/public/image/etc/LogoA.png`).default.src} alt="" />
                                    }
                                    <p>{selectContent.home_team}</p>
                                </div>
                                <div>
                                    <p><LocaleFormat date={selectContent.game_time} format={"MMM DD (ddd) HH:mm"} /></p>
                                    <p>VS</p>
                                    {/* <p>조회수 {al.readCount || 0}</p> */}
                                </div>
                                <div>
                                    {
                                        selectContent.away_team_logo
                                            ? <img src={selectContent.away_team_logo}
                                                alt="logo B"
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null;
                                                    e.currentTarget.src = `${require('@/public/image/etc/LogoB.png').default.src}`;
                                                }} />
                                            : <img className="team-amb" src={require(`@/public/image/etc/LogoB.png`).default.src} alt="" />
                                    }
                                    <p>{selectContent.away_team}</p>
                                </div>
                            </li>
                        </ul>
                        <div className="expectations p-t-10 p-b-10">
                            <div className="ex-header">{t("예상")}</div>
                            <ul className="">
                                {
                                    match.match_result
                                    && <li>
                                        <div className="selection-info">
                                            <div className="market">{t("승패")}</div>
                                            <div className="selection">
                                                <span>{match.match_result}</span>
                                                <span>{match.odds}</span>
                                            </div>
                                        </div>
                                        <div>{t("추천")}</div>
                                    </li>
                                }
                                {
                                    handicap.handicap_result
                                    && <li>
                                        <div className="selection-info">
                                            <div className="market">{t("핸디캡")}</div>
                                            <div className="selection">
                                                <span>{handicap.handicap_result}</span>
                                                <span>{handicap.odds}</span>
                                            </div>
                                        </div>
                                        <div>{t("추천")}</div>
                                    </li>
                                }
                                {
                                    under_over.under_over_result
                                    && <li>
                                        <div className="selection-info">
                                            <div className="market">{t("언더/오버")}</div>
                                            <div className="selection">
                                                <span>{under_over.under_over_result}</span>
                                                <span>{under_over.odds}</span>
                                            </div>
                                        </div>
                                        <div>{t("추천")}</div>
                                    </li>
                                }
                            </ul>
                        </div>
                        <div className="free-style p-b-10 p-t-10">
                            <ParsedHtmlContent html={selectContent?.content ?? ""} />
                        </div>
                        <footer>
                            <img src={mark.src} alt="mark" />
                            <p>{a("AnalysisWarning")}</p>
                        </footer>
                    </main>
                </>
            )} />
    )
}